import React from 'react'
import { Route, Routes, Navigate, useParams } from 'react-router-dom'
import HeaderComponent from './HeaderComponent'
import DashboardComponent from './DashboardComponent'
import ReportComponent from './ReportComponent'
import AdditionalServicesPage from './AdditionalServicesPage'
import CustomReportPage from './CustomReportPage'
import { AppsProvider, useApps } from '../contexts/AppsContext'
import './Navigation.css'
import { useTheme } from '../contexts/ThemeContext'

const CoreAppReports: React.FC = () => {
  const { appKey } = useParams()
  const { apps, loading } = useApps()
  const app = apps.find(a => a.key === appKey)

  if (loading) return null
  if (!app) return <Navigate to="/dashboard" replace />
  if (app.tier === 'additional') return <Navigate to={`/additional/${app.key}`} replace />
  // key: remount per app so the report list resets its state when switching tabs
  return <ReportComponent key={app.key} app={app} />
}

const MainContent: React.FC = () => {
  const { theme, toggleTheme } = useTheme()
  const { apps } = useApps()

  return (
    <div className="main-container">
      <HeaderComponent theme={theme} onToggleTheme={toggleTheme} coreApps={apps.filter(a => a.tier === 'core')} />
      <Routes>
        <Route path="/report/:reportName/custom" element={<CustomReportPage />} />
        <Route path="/dashboard" element={<DashboardComponent />} />
        <Route path="/reports/:appKey" element={<CoreAppReports />} />
        <Route path="/additional" element={<AdditionalServicesPage />} />
        <Route path="/additional/:appKey" element={<AdditionalServicesPage />} />
        {/* Pre-registry routes, kept so old bookmarks still land */}
        <Route path="/orderPortalReports" element={<Navigate to="/reports/orderportal" replace />} />
        <Route path="/salestrackReports" element={<Navigate to="/reports/salestrack" replace />} />
        <Route path="/iquoteReports" element={<Navigate to="/reports/iquote" replace />} />
        <Route path="/netsuiteReports" element={<Navigate to="/additional/netsuite" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </div>
  )
}

const Main: React.FC = () => (
  <AppsProvider>
    <MainContent />
  </AppsProvider>
)

export default Main
